import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Table, Modal, Input, Button, Form, Radio, Checkbox } from "antd";
import { BiEdit } from "react-icons/bi";
import { AiFillDelete } from "react-icons/ai";
import { Link } from "react-router-dom";
import axios from "axios";
import { base_url } from "../utils/baseUrl";
import CustomModal from "../components/CustomModal"; // Confirm if this is your custom modal
import { toast } from "react-toastify";

const columns = [
  {
    title: "SNo",
    dataIndex: "key",
  },
  {
    title: "Code",
    dataIndex: "code",
    sorter: (a, b) => a.code.localeCompare(b.code),
  },
  {
    title: "Discount",
    dataIndex: "discount",
    render: (_, record) => (
      <span>
        {record.discount_percentage
          ? `${record.discount_percentage}%`
          : `₹${record.discount_flat}`}
      </span>
    ),
  },
  {
    title: "Description",
    dataIndex: "description",
  },
  {
    title: "Min Amount",
    dataIndex: "min_amount",
    render: (min_amount) => min_amount ? `₹${min_amount}` : '-',
  },
  {
    title: "Max Amount",
    dataIndex: "max_amount",
    render: (max_amount) => max_amount ? `₹${max_amount}` : '-',
  },
  {
    title: "Valid From",
    dataIndex: "valid_from",
  },
  {
    title: "Valid To",
    dataIndex: "valid_to",
  },
  {
    title: "Show on Frontend",
    dataIndex: "show_on_frontend",
    render: (show_on_frontend) => (show_on_frontend ? "Yes" : "No"),
  },
  {
    title: "Action",
    dataIndex: "action",
  },
];

const Couponlist = () => {
  const [open, setOpen] = useState(false);
  const [couponId, setCouponId] = useState("");
  const [coupons, setCoupons] = useState([]);
  const [editingCoupon, setEditingCoupon] = useState(null); // To manage the editing coupon data
  const [form] = Form.useForm(); // Add this line
  const navigate = useNavigate();

  const adminToken = localStorage.getItem("adminToken");
  console.log("Admin Token:", adminToken);

  useEffect(() => {
    const adminToken = localStorage.getItem("adminToken");
    if (!adminToken) {
      navigate("/");
    }
  }, [navigate]);
  useEffect(() => {
    axios
      .get(`${base_url}/api/discounts/allDiscounts`)
      .then((response) => {
        setCoupons(response.data);
      })
      .catch((error) => {
        console.error("Error fetching coupons:", error);
      });
  }, []);

  const deleteCoupon = (id) => {
    axios
      .delete(`${base_url}/api/discounts/discounts/${id}`)
      .then((response) => {
        setCoupons(coupons.filter((coupon) => coupon.discount_id !== id));
        setOpen(false);
      })
      .catch((error) => {
        console.error("Error deleting coupon:", error);
      });
  };

  const showEditModal = (coupon) => {
    // Set the current discount type based on which value exists
    const discountType = coupon.discount_percentage ? 'percentage' : 'flat';

    // Set the form values
    form.setFieldsValue({
      code: coupon.code,
      discountType: discountType,
      discount_percentage: coupon.discount_percentage,
      discount_flat: coupon.discount_flat,
      description: coupon.description,
      min_amount: coupon.min_amount,
      max_amount: coupon.max_amount,
      valid_from: new Date(coupon.valid_from).toISOString().split('T')[0],
      valid_to: new Date(coupon.valid_to).toISOString().split('T')[0],
      max_usage: coupon.max_usage,
      show_on_frontend: coupon.show_on_frontend,
    });

    setEditingCoupon(coupon);
  };

  const hideEditModal = () => {
    setEditingCoupon(null); // Close modal
  };

  const handleUpdateCoupon = (values) => {
    const updatedCoupon = {
      ...editingCoupon,
      ...values,
      // Set discount values based on selected type
      discount_percentage: values.discountType === 'percentage' ? values.discount_percentage : null,
      discount_flat: values.discountType === 'flat' ? values.discount_flat : null
    };

    // Validate that only one discount type is set
    if ((updatedCoupon.discount_percentage && updatedCoupon.discount_flat) ||
      (!updatedCoupon.discount_percentage && !updatedCoupon.discount_flat)) {
      toast.error("Please select either percentage or flat discount");
      return;
    }

    axios
      .put(`${base_url}/api/discounts/discounts/${editingCoupon.discount_id}`, updatedCoupon)
      .then((response) => {
        setCoupons(
          coupons.map((coupon) =>
            coupon.discount_id === editingCoupon.discount_id ? updatedCoupon : coupon
          )
        );
        hideEditModal();
        toast.success("Coupon updated successfully");
      })
      .catch((error) => {
        console.error("Error updating coupon:", error);
        toast.error(error.response?.data?.error || "Error updating coupon");
      });
  };

  const dataSource = coupons.map((coupon, index) => ({
    key: index + 1,
    ...coupon,
    valid_from: new Date(coupon.valid_from).toLocaleDateString(),
    valid_to: new Date(coupon.valid_to).toLocaleDateString(),
    action: (
      <>
        <Link to="#" onClick={() => showEditModal(coupon)} className="text-danger">
          <BiEdit />
        </Link>
        <button
          className="ms-3 text-danger bg-transparent border-0"
          onClick={() => deleteCoupon(coupon.discount_id)}
        >
          <AiFillDelete />
        </button>
      </>
    ),
  }));

  return (
    <div>
      <h3 className="mb-4">Coupons</h3>
      <Table columns={columns} dataSource={dataSource} />

      {/* Edit Coupon Modal */}
      {editingCoupon && (
        <Modal
          title="Edit Coupon"
          visible={true}
          onCancel={hideEditModal}
          footer={null}
        >
          <Form
            form={form}
            onFinish={handleUpdateCoupon}
          >
            <Form.Item
              label="Coupon Code"
              name="code"
              rules={[{ required: true, message: "Please input the coupon code!" }]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              label="Discount Type"
              name="discountType"
              rules={[{ required: true, message: "Please select discount type!" }]}
            >
              <Radio.Group>
                <Radio value="percentage">Percentage</Radio>
                <Radio value="flat">Flat Amount</Radio>
              </Radio.Group>
            </Form.Item>

            <Form.Item
              noStyle
              shouldUpdate={(prevValues, currentValues) =>
                prevValues.discountType !== currentValues.discountType
              }
            >
              {({ getFieldValue }) =>
                getFieldValue('discountType') === 'percentage' ? (
                  <Form.Item
                    name="discount_percentage"
                    label="Percentage Discount"
                    rules={[{ required: true, message: 'Please input the discount percentage!' }]}
                  >
                    <Input type="number" min="0" max="100" />
                  </Form.Item>
                ) : (
                  <Form.Item
                    name="discount_flat"
                    label="Flat Discount Amount"
                    rules={[{ required: true, message: 'Please input the flat discount amount!' }]}
                  >
                    <Input type="number" min="0" />
                  </Form.Item>
                )
              }
            </Form.Item>

            <Form.Item
              label="Description"
              name="description"
              rules={[{ required: true, message: "Please input the coupon description!" }]}
            >
              <Input.TextArea rows={4} />
            </Form.Item>

            <Form.Item
              label="Minimum Amount"
              name="min_amount"
              rules={[{ required: true, message: "Please input the minimum order amount!" }]}
            >
              <Input
                type="number"
                min="0"
                placeholder="Minimum order amount required"
              />
            </Form.Item>

            <Form.Item
              label="Maximum Amount"
              name="max_amount"
              rules={[{ required: true, message: "Please input the maximum discount amount!" }]}
              dependencies={['min_amount']}
            >
              <Input
                type="number"
                min="0"
                placeholder="Maximum discount amount allowed"
              />
            </Form.Item>

            <Form.Item
              label="Valid From"
              name="valid_from"
              rules={[{ required: true, message: "Please select the start date!" }]}
            >
              <Input type="date" />
            </Form.Item>

            <Form.Item
              label="Valid To"
              name="valid_to"
              rules={[{ required: true, message: "Please select the end date!" }]}
            >
              <Input type="date" />
            </Form.Item>

            <Form.Item
              name="show_on_frontend"
              valuePropName="checked"
            >
              <Checkbox>Show on Frontend</Checkbox>
            </Form.Item>

            <Form.Item>
              <Button type="primary" htmlType="submit">
                Update Coupon
              </Button>
            </Form.Item>
          </Form>
        </Modal>
      )}

      {/* Delete Confirmation Modal */}
      <CustomModal
        open={open}
        hideModal={() => setOpen(false)}
        performAction={() => deleteCoupon(couponId)}
        title="Are you sure you want to delete this coupon?"
      />
    </div>
  );
};

export default Couponlist;
